import { render, staticRenderFns } from "./OrderSampleButton.vue?vue&type=template&id=532a262a&scoped=true"
import script from "./OrderSampleButton.vue?vue&type=script&lang=ts"
export * from "./OrderSampleButton.vue?vue&type=script&lang=ts"
import style0 from "./OrderSampleButton.vue?vue&type=style&index=0&id=532a262a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a262a",
  null
  
)

export default component.exports